import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { GiroService } from './services/giro.service';
import { IGiro } from './interfaces/giro.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-giros',
  templateUrl: './giros.component.html',
  providers: [MessageService]
})
export class GirosComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedGiro: IGiro | null = null;
  dataSource: IGiro[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'clave_giro', header: 'Clave Giro', sortable: true },
    { field: 'tipo_dedicacion', header: 'Tipo Giro', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private giroService: GiroService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.giroService.getGiros().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los giros'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar giros:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los giros'
        });
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedGiro = null;
    this.displayDialog = true;
  }

  openUpdate(row: IGiro): void {
    this.selectedGiro = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: IGiro): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este giro?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.giroService.deleteGiro(row.clave_giro).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Giro eliminado correctamente'
              });
              this.loadData();
            } else {
              Swal.fire(
                'Error',
                'Error al eliminar el giro',
                'error'
              );
            }
          },
          error: (error) => {
            console.error('Error:', error);
            Swal.fire(
              'Error',
              'Error al eliminar el giro',
              'error'
            );
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedGiro = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }
} 